export async function impersonateUser(userId: number) {
  const res = await fetch("/auth/impersonate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error || "Failed to start impersonation");
  }
}

export async function stopImpersonation() {
  const res = await fetch("/auth/stop-impersonate", { method: "POST" });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error || "Failed to stop impersonation");
  }
}
